export default function Demerits() {
  const demerits = [
    {
      icon: 'ri-mail-line',
      title: 'メールマガジンが多い',
      description: '大手ECモール系カードに入会すると、メールマガジンが頻繁に届きます。キャンペーン情報やお得な情報が多いのですが、人によっては煩わしく感じることも。ただし、メール配信設定で受信を制限することは可能です。',
      solution: '会員サイトの設定画面から、必要なメールだけを受信するように変更できます。',
    },
    {
      icon: 'ri-phone-line',
      title: 'カスタマーサポートが繋がりにくい',
      description: '会員数が多いため、電話でのカスタマーサポートが混雑していることがあります。特に月末や給料日後は繋がりにくい傾向があります。ただし、チャットサポートやFAQページも充実しているので、そちらを活用すれば問題ありません。',
      solution: 'チャットサポートやメールでの問い合わせを活用すれば、スムーズに対応してもらえます。',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#BF0000] mb-3 text-center">
          大手ECモール系カードのデメリット
        </h2>
        <p className="text-gray-600 text-center mb-12">正直に伝える注意点と対策方法</p>

        <div className="space-y-6">
          {demerits.map((demerit, index) => (
            <div key={index} className="bg-[#FFF8F8] rounded-xl shadow-md p-6 md:p-8 border border-[#FFE0E0]">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B6B] rounded-full flex-shrink-0">
                  <i className={`${demerit.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="bg-[#FF6B6B] text-white text-xs font-bold px-3 py-1 rounded-full">
                      デメリット{index + 1}
                    </span>
                    <h3 className="text-lg md:text-xl font-bold text-[#BF0000]">{demerit.title}</h3>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
                    {demerit.description}
                  </p>
                  <div className="bg-white border-l-4 border-[#4CAF50] px-4 py-2 rounded">
                    <p className="text-[#BF0000] text-xs md:text-sm font-medium">
                      <i className="ri-lightbulb-line mr-1 text-[#4CAF50]"></i>
                      <strong>対策：</strong>{demerit.solution}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#FFF0F0] rounded-xl p-6 text-center">
          <p className="text-gray-700 text-sm md:text-base">
            <strong className="text-[#BF0000]">総評：</strong>
            デメリットはあるものの、年会費永年無料で1%の高還元率を考えると、
            <strong className="text-[#FF9900]">ECモールユーザーには必携</strong>のカードです。
          </p>
        </div>
      </div>
    </section>
  );
}
